import {Card, CardContent, Divider, Grid, Modal, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import ReactJson from 'react-json-view'
import Label from '../../../components/Label';
import {getWcvType, WcvLog, WcvLogLevels} from '../../../graphql/logs.datatypes';
import {EST, formatDateTime} from '../../../utils/formatters';
import {isHtml} from '../../../utils/isHtml';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        outline: 'none',
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '90%',
        overflowY: 'auto',
        maxWidth: '95%'
    },
    container: {
        marginTop: theme.spacing(3)
    },
    iFrame: {
        borderColor: theme.palette.grey['500'],
        borderWidth: 1,
        borderStyle: 'solid',
        width: '100%',
    }
}));

const LogDetailsModal = (props: { log: WcvLog, className?: string, setSelectedLog: (log: WcvLog | null) => void, }) => {
    const {log} = props;
    const classes = useStyles();
    const logLevel = WcvLogLevels[log.level];
    const logType = getWcvType(log.type);

    const payloadJson = log.payload ? JSON.parse(log.payload) : null;
    const bodyHtml = !!(payloadJson && payloadJson.body && isHtml(payloadJson.body));


    return (
        <div>
            {props.log && (
              <Modal open={true} onClose={() => props.setSelectedLog(null)}>
                  <Card className={clsx(classes.root, props.className)} >
                      <CardContent>
                          <Typography gutterBottom variant="h3">
                              Log Details
                          </Typography>
                          <Grid className={classes.container} container spacing={3}>
                              <Grid item md={1}><Typography>id:</Typography></Grid>
                              <Grid item md={2}><Typography>{log.id}</Typography></Grid>
                              <Grid item md={1}><Typography>level:</Typography></Grid>
                              <Grid item md={2}><Label color={logLevel.colour}>{logLevel.name}</Label></Grid>
                              <Grid item md={1}>code:</Grid>
                              <Grid item md={2}>{log.code}</Grid>
                              <Grid item md={1}>resolved:</Grid>
                              <Grid item md={2}>{log.resolved}</Grid>

                              <Grid item md={1}>Time:</Grid>
                              <Grid item md={5}>{formatDateTime(log.created_at)}</Grid>
                              <Grid item md={1}>owner:</Grid>
                              <Grid item md={5}>{log.user ? log.user.email : 'system'}</Grid>

                              <Grid item md={1}>type:</Grid>
                              <Grid item md={2}><Label color={logType.colour}>{logType.name}</Label></Grid>
                              {!log.type_id && (<Grid item md={9}>none</Grid>)}
                              {log.targetUser && (<Grid item md={9}>{log.targetUser.email}</Grid>)}
                              {log.targetRole && (<Grid item md={9}>{log.targetRole.name}</Grid>)}
                              {log.targetPermission && (<Grid item md={9}>{log.targetPermission.name}</Grid>)}

                              <Grid item md={12}><Divider /></Grid>

                              <Grid item md={2}>description:</Grid>
                              <Grid item md={10}>{log.description}</Grid>

                              {log.payload && (
                                <React.Fragment>
                                    <Grid item md={2}>payload:</Grid>
                                    <Grid item md={10}>{log.payload && (<ReactJson collapsed={bodyHtml} src={payloadJson} />)}</Grid>
                                </React.Fragment>
                              )}
                              {bodyHtml && (
                                <React.Fragment>
                                    <Grid item md={2}>email:</Grid>
                                    <Grid item md={10}><iframe srcDoc={payloadJson.body} className={classes.iFrame} /></Grid>
                                </React.Fragment>
                              )}
                          </Grid>
                      </CardContent>
                  </Card>
              </Modal>
            )}
        </div>
    );
};

export default LogDetailsModal;
